import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the KhudaKiAwazDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class KhudaKiAwazDataProvider {
  //public items: any;

  constructor(public http: HttpClient) {
    console.log('Hello KhudaKiAwazDataProvider Provider');
  }

  getRemoteData(){
    //let data:Observable<any>;
    //data = this.http.get("https://geetkikitab.com/mobile_rest/hymn_data.json");
    //data.subscribe(result =>{
    //  this.items=result;
    //})
    
    //loading remote hymn data
   return this.http.get("https://geetkikitab.com/mobile_rest/hymn_data.json");
  }

}



// WEBPACK FOOTER //
// ./src/providers/khuda-ki-awaz-data/khuda-ki-awaz-data.ts